// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"Loading_loadingWrapper__1mPJb","positionCenter":"Loading_positionCenter__UW3oL","positionInRightPart":"Loading_positionInRightPart__1a-pb"};